const NotFound = () => (
  <div>
    <p>The page you're looking for was not found!</p>
  </div>
);

export { NotFound };
